<div class="host-create-task">
  <form nz-form class="form-container" [formGroup]="form">
    <div class="left">
      <div class="form-item flex-center">
        <!-- 类型 -->
        <p class="title">{{ 'task.word.type.text' | translate }}</p>
        <nz-select
          style="width: 212px"
          formControlName="type"
          [nzDisabled]="data?.id"
          (ngModelChange)="typeChange()"
        >
          <nz-option
            *ngFor="let type of typeList"
            [nzLabel]="type.label"
            [nzValue]="type.value"
          >
          </nz-option>
        </nz-select>
      </div>
      <div class="form-item flex-center">
        <!-- 房间 -->
        <p class="title">{{ 'word.house' | translate }}</p>
        <host-search-house-in-group-and-type-with-input
          [allowMultiSelect]="false"
          [showWidth]="212"
          [noBorder]="true"
          [defaultHouses]="hasCheckedHouses"
          [defaultHouseTitle]="defaultHouseTitle"
          (checkedHousesChange)="checkedHousesChange($event)"
        >
        </host-search-house-in-group-and-type-with-input>
      </div>
      <div class="form-item flex-center">
        <!-- 日期 -->
        <p class="title">{{ 'word.date' | translate }}</p>
        <host-input-with-error
          [showError]="checking && invalid(form.get('date').value)"
          errorText="{{ 'errorText.choose_date_required' | translate }}"
        >
          <nz-date-picker
            [nzFormat]="angularDateFormat"
            formControlName="date"
            [nzShowToday]="false"
          ></nz-date-picker>
        </host-input-with-error>
      </div>
      <div class="form-item flex-center">
        <!-- 时间 -->
        <p class="title">{{ 'word.time' | translate }}</p>
        <host-input-with-error
          [showError]="checking && invalid(form.get('time').value)"
          errorText="{{ 'errorText.time_required' | translate }}"
        >
          <nz-time-picker
            [nzFormat]="angularTimeFormat"
            [nzUse12Hours]="use12Hours"
            [nzMinuteStep]="10"
            formControlName="time"
          ></nz-time-picker>
        </host-input-with-error>
      </div>
      <div class="form-item flex-center">
        <!-- 被分配人 -->
        <p class="title">{{ 'task.word.assignee' | translate }}</p>
        <div class="form-control flex-1">
          <host-cleaner-assign-picker
            [placeholder]="'task.create.placeholder.staff_optional' | translate"
            [multiple]="false"
            formControlName="assignee"></host-cleaner-assign-picker>
        </div>
<!--        <nz-select-->
<!--          style="width: 212px"-->
<!--          [nzPlaceHolder]="'task.create.placeholder.staff_optional' | translate"-->
<!--          formControlName="assignee"-->
<!--        >-->
<!--          <nz-option-->
<!--            *ngFor="let assignee of assigneeList"-->
<!--            [nzLabel]="assignee.name"-->
<!--            [nzValue]="assignee.id"-->
<!--          >-->
<!--          </nz-option>-->
<!--        </nz-select>-->
      </div>
      <!-- 只有当任务类型是保洁的时候才会出现该选项 -->
      <div class="form-item flex-center" *ngIf="form.get('type').value === 0">
        <!-- 保洁等级 -->
        <p class="title">{{ 'task.word.clean_level' | translate }}</p>
        <nz-select
          style="width: 212px"
          formControlName="cleanLevel"
          (ngModelChange)="cleanLevelChange()"
        >
          <nz-option
            *ngFor="let level of cleanLevelList"
            [nzLabel]="level.i18nKey | translate"
            [nzValue]="level.value"
          >
          </nz-option>
        </nz-select>
      </div>
      <div class="form-item flex-center" style="height: 32px">
        <!-- 费用 -->
        <p class="title">{{ 'task.word.fee' | translate }}</p>
        <nz-input-number
          style="width: 130px"
          formControlName="fee"
          [nzMin]="0"
          [nzMax]="maxAmount"
          [nzPrecision]="2"
        ></nz-input-number>
        <nz-select style="width: 82px" formControlName="currency">
          <nz-option
            *ngFor="let opt of currencyList"
            [nzLabel]="opt"
            [nzValue]="opt"
          >
          </nz-option>
        </nz-select>
      </div>
      <div
        class="form-item flex-center included"
        *ngIf="
          !data?.id && form.get('fee').value > 0
        "
      >
        <label nz-checkbox formControlName="included">
          <!-- 计入收支 -->
          {{ 'task.create.add_to_transactions' | translate }}
        </label>
      </div>
      <div
        *ngIf="!data?.id && form.get('included').value"
        class="form-item flex-center"
      >
        <!-- 支付方式 -->
        <p class="title">
          {{ 'task.create.payment' | translate }}
        </p>
        <nz-select
          style="width: 212px"
          nzPlaceHolder="{{ 'placeholder.payment_method' | translate }}"
          formControlName="payment_method"
        >
          <nz-option
            *ngFor="let opt of listOfMethodOption"
            [nzLabel]="opt.method_name"
            [nzValue]="opt.code"
          ></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="right">
      <div class="form-item">
        <p class="title">
          <!-- 描述 -->
          {{ 'task.create.description' | translate }}
        </p>
        <textarea
          rows="4"
          nz-input
          style="width: 316px"
          formControlName="note"
          [attr.placeholder]="
            'task.create.placeholder.description_optional' | translate
          "
        ></textarea>
      </div>
      <div class="form-item">
        <p class="title">
          <!-- 附件 -->
          {{ 'task.word.attachment' | translate }}
        </p>
        <host-base-image-upload
          formControlName="appendix"
          showBigImg="true"
        ></host-base-image-upload>
      </div>
    </div>
  </form>
  <div class="footer">
    <a
      *ngIf="form.get('type').value === 0; else emptyLeftFooter"
      href="javascript:void(0)"
      (click)="toTasksFee()"
    >
      <!-- 设置房间默认保洁费 -->
      {{ 'task.create.set_default_clean_fee' | translate }}
    </a>
    <ng-template #emptyLeftFooter><div></div></ng-template>
    <div class="button">
      <button nz-button (click)="cancel()">
        {{ 'word.cancel' | translate }}
      </button>
      <button nz-button nzType="primary" [nzLoading]="btnLoading" (click)="save()">
        {{ 'word.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
